import React, {Suspense} from 'react';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "Transfers" */ './views/main.c'));

const Transfers = props => {
    let {match = {}} = props;

    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main {...props} action={match.params && match.params.action} />
        </Suspense>
    );
};

export default Transfers;
